import React, { useEffect } from "react";
import Loading from "components/Loading";
import HeadTags from "components/HeadTags";
import PropTypes from "prop-types";

const DynamicTextPage = ({ loading, title, state, policy }) => {
  useEffect(() => {
    if (policy && !loading) {
      const script = document.createElement("script");
      const addScript = document.getElementById("cookieScript");

      script.id = "CookieDeclaration";
      script.src = policy;
      script.async = true;

      if (!document.getElementById("CookieDeclaration")) {
        addScript.appendChild(script);
      }
    }
  }, [policy, loading]);

  function createMarkup() {
    return { __html: state };
  }

  return (
    <>
      <HeadTags title={title} />
      <div className="contentPage">
        <div className="contentPage__headingDiv">
          <h1>{title}</h1>
        </div>
        <div className="contentPage__content">
          {loading && (
            <div className="loadingHolder">
              <Loading />
            </div>
          )}
          {state !== null && <div dangerouslySetInnerHTML={createMarkup()} />}
          {policy !== null && <div id="cookieScript" />}
        </div>
      </div>
    </>
  );
};
DynamicTextPage.propTypes = {
  state: PropTypes.string,
  loading: PropTypes.bool,
  title: PropTypes.string,
  policy: PropTypes.string
};
DynamicTextPage.defaultProps = {
  state: undefined,
  loading: undefined,
  title: undefined,
  policy: undefined
};
export default DynamicTextPage;
